import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface UploadCacheStore {
    tempUrl: string | null;
    setTempUrl: (url: string | null) => void;
}

export const useUploadCache = create<UploadCacheStore>()(
    devtools(
        immer((set, _) => ({
            tempUrl: null,
            setTempUrl: async (tempUrl: string | null) => set({
                tempUrl
            })
        })),
    ),
);
